<div>
    <canvas baseChart
            [datasets]="datasets"
            [labels]="chartLabels"
            [options]="chartOptions"
            chartType="line">
    </canvas>
</div>
